<template>
  <div class="login">
    <div class="login__form-admin">
      <!-- <img
        src="https://kiritek-web-documents.s3-us-west-2.amazonaws.com/trust1/logot1.png"
        style="width: 30%; margin-bottom: 4rem;"
        alt="logo-t1"
      /> -->

      <div class="form-border" style="margin-top: 20%;">
        <div class="t1-subtitle" style="font-family: Open Sans; font-size: 14px;max-width: 40rem; margin-left: auto; margin-right: auto; padding-bottom: 2rem; text-align: justify;">Hola <span style="font-weight: 600" >{{userEmail}}</span> para completar tu registro crea y confirma tu contraseña.</div>

        <div style="max-width: 40rem; margin-left: auto; margin-right: auto;" class="form__group">
          <label class="form__label">Contraseña:</label>
          <input :type="passwordVisible" v-model="password" class="form__input input-password" />
          <img
            @mousedown="togglePwdIcon(true)"
            @mouseup="togglePwdIcon(false)"
            @mouseleave="togglePwdIcon(false)"
            :src="'/img/icons/'+showPasswordIcon"
            class="show-password"
          />
          <validation-error :validation="$v.password" type="password" />
        </div>
        <div style="max-width: 40rem; margin-left: auto; margin-right: auto;" class="form__group">
          <label class="form__label">Confirmar contraseña:</label>
          <input
            :type="repeatPasswordVisible"
            v-model="repeatPassword"
            class="form__input input-password"
          />
          <img
            @mousedown="toggleRepeatPwdIcon(true)"
            @mouseup="toggleRepeatPwdIcon(false)"
            @mouseleave="toggleRepeatPwdIcon(false)"
            :src="'/img/icons/'+showRepeatPasswordIcon"
            class="show-password"
          />
          <validation-error :validation="$v.repeatPassword" type="repetpassword" />
        </div>
        <div class="form__group">
          <btn type="primary" @onClick="createPassword" text="Crear contraseña" />
        </div>
      </div>
    </div>
    <div class="login__bg-admin"></div>
    <Popup ref="registercomplete" size="xs">
      <div class="text-center">
        <h1 class="text-center title-forgot-pwd mb-3">REGISTRO CONFIRMADO</h1>
        <p
          class="forgot-pwd-text"
          style="font-size: 19px;"
        >La contraseña ha sido creada correctamente.</p>
        <img src="/img/icons/ok.svg" width="200px" height="auto" alt />
       <div class="form__group">
          <btn type="primary" @onClick="iniciarSesion" text="Ok" />
        </div>
      </div>
    </Popup>
  </div>
</template>
<script>
import Btn from "../core/Button";
  import Popup from "../core/Popup";

import { mdbContainer, mdbRow, mdbCol } from "mdbvue";
import { mapActions, mapState, mapGetters } from "vuex";
import { required, email, minLength, alphaNum, maxLength, sameAs } from "vuelidate/lib/validators";
import { hasNumeric, hasUppercase } from "../../validations";
import { Decrypt } from "../../utils/utils";
import ValidationError from "./misc/ValidationError";
import Axios from "axios";

export default {
  name: "completRegister",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    Btn,
    Popup,
    ValidationError
  },
  data() {
    return {
      password: "",
      repeatPassword: "",
      passwordVisible: "password",
      repeatPasswordVisible: "password",
      loggin: true,
      code: "",
      userEmail: ""
    };
  },
  validations: {
    password: {
      required,
      minLength: minLength(8),
      hasUppercase,
      hasNumeric
    },
    repeatPassword: {
      required,
      sameAs: sameAs("password")
    }
  },
   mounted() {
    //console.log(this.$route.query.user)
    //console.log(this.$route.query.email)
    this.code=this.$route.query.user;
    this.userEmail=this.$route.query.email;
    // //console.log(this.$router.query.data)
    // let data = Decrypt(this.$router.query.data)
    // this.code=data.split("&")[0];
    // this.userEmail=data.split("&")[1];
    // //console.log(this.code)
    // //console.log(this.userEmail)

  },
  computed: {
    ...mapState({ authenticated: state => state.auth.authenticated, userType: state => state.auth.userType, clubName: state => state.auth.club }),
    showPasswordIcon() {
      let icon = "";
      if (this.passwordVisible == "password") {
        icon = "password-hidden.svg";
      } else {
        icon = "password-visible.svg";
      }
      return icon;
    },
    showRepeatPasswordIcon() {
      let icon = "";
      if (this.repeatPasswordVisible == "password") {
        icon = "password-hidden.svg";
      } else {
        icon = "password-visible.svg";
      }
      return icon;
    }
  },
  methods: {
      ...mapActions(["createUserPassword", "authenticate"]),
       togglePwdIcon(icon){
                if(icon){
                    this.passwordVisible = 'text';
                } else {
                    this.passwordVisible = 'password';
                }
            },
            toggleRepeatPwdIcon(icon){
                if(icon){
                    this.repeatPasswordVisible = 'text';
                } else {
                    this.repeatPasswordVisible = 'password';
                }
            },
            iniciarSesion(){
              this.$refs.registercomplete.toggleModal();
              if(this.clubName != null){
                this.$notify.success({ message: "Bienvenido al sistema de solicitudes de club de golf", position: 'bottom right', timeOut: 5000 })
                this.$router.push("/admin"); 
              }
              else{
                this.$store.commit("clearAuthentication")
                this.$router.push("/"); 
              }
            },
            async createPassword(){
                this.$v.$touch();
                if(this.$v.password.required && this.$v.repeatPassword.sameAs && this.code != undefined ){
                //if(this.$v.password.required && this.$v.repeatPassword.sameAs && this.code != undefined && this.password.length > 7){
                    try {
                        let data = {};
                        data.code = this.code;
                        data.password = this.password;
                        let response = await this.createUserPassword(data);
                        if(response.data.status == 200){
                            await this.authenticate({ email: this.userEmail, password: this.password });
                            if(this.authenticated){
                                this.$refs.registercomplete.toggleModal();
                            }
                        }
                    } catch (e){
                        //console.log(e)
                        this.$notify.error({ message: e.response.errorDetails, position: "top right", timeOut: 5000 });
                    }
                }
            }
  }
};
</script>
<style lang="scss">
$medium-grey: #828282;

.input-password {
  display: inline;
}

.btn-inline {
  display: inline;
  &:not(:last-child) {
    padding-right: 1.5rem;
  }
}

.show-password {
  position: absolute;
  padding-top: 1.1rem;
  padding-left: 0.5rem;
  display: inline;
}

.title-forgot-pwd {
  text-transform: uppercase;
  color: $medium-grey;
  font-weight: 400;
  font-family: Josefin Sans;
  font-size: 2rem;
}

.forgot-pwd-text {
  color: $medium-grey;
  font-size: 1.2rem;
  padding: 0.5rem 0.5rem;
  text-align: center;
}
</style>